import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

import React from "react";
import { CustomTable, SearchTableInput } from "../../../components";
import PodTypeModal from "./PodTypeModal";
import { useNavigate } from "react-router-dom";
import { podMachineTableHeading } from "../../../assets/lib/pod";

const customStyle = makeStyles({
  root: {
    padding: "20px 40px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  buttonContainer: {
    height: "50px",
    display: "flex",
    justifyContent: "space-between",
  },
  actionBtn: {
    display: "flex",
    gap: "30px",
  },
  '@media (max-width: 390px)': {
    root: {
      padding: "5px 5px", 
      gap: "65px", 
      width:"80vw",
    },
    buttonContainer: {
      height: "35px",
      justifyContent: "space-evenly",
      flexWrap: "wrap",
    },
    actionBtn: {
      marginTop:"10px",
      marginLeft:"-120px",
      gap: "5px",
      flexDirection: "row", 
      height: "35px",
    },
  },
});

const Layout = (props) => {
  const {
    podMachineTableData,
    podMachineState,
    isTableLoading,
    currentPage,
    totalLength,
    handlePageChange,
    handlePageSize,
    handleSearchQuery,
    handleTableSorting,
    isModalOpen,
    setIsModalOpen,
    handleSubmitModal,
    getPodMachineInput,
    errorFields,
    fetchPodMachineNumber,
    isModalLoading,
  } = props;
  const classes = customStyle();
  const navigate = useNavigate();

  return (
    <div className={classes.root}>
      <div className={classes.buttonContainer}>
        <SearchTableInput
          tableHeading={podMachineTableHeading}
          handleSearchQuery={handleSearchQuery}
        />
        <div className={classes.actionBtn}>
          <Button
            variant="contained"
            style={{
              color: "white",
              backgroundColor: "#FF5722",
              padding: "12px 24px",
              borderRadius: "10px",
            }}
            onClick={() => {
              setIsModalOpen(true);
              fetchPodMachineNumber();
            }}
          >
            Add New Pod
          </Button>
        </div>
      </div>
      <CustomTable
        columns={podMachineTableHeading}
        data={podMachineTableData}
        // actions={actions}
        isLoading={isTableLoading}
        currentPage={currentPage}
        totalLength={totalLength}
        handlePageChange={handlePageChange}
        handlePageSize={handlePageSize}
        handleTableSorting={handleTableSorting}
      />
      <PodTypeModal
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        handleSubmitModal={handleSubmitModal}
        podMachineState={podMachineState}
        getPodMachineInput={getPodMachineInput}
        errorFields={errorFields}
        loadingModal={isModalLoading}
      />
    </div>
  );
};

export default Layout;
